var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{staticClass:"pe-2 pb-2",attrs:{"height":"100%","width":"100%"}},[_c('div',{ref:"schedulerContainer",staticClass:"AIVA_Scheculer h-100"}),_c('div',{staticClass:"dhx_minical_icon",attrs:{"id":"dhx_minical_icon"}},[_vm._v(" ")]),_c('RecurringEvent',{ref:"recurringEvent"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }